import { Button } from '@/components/common/Button';
import { FlexCol, FlexRow } from '@/components/common/Flex';
import Icon from '@/components/common/icons/Icon';
import { Text } from '@/components/common/Typography';
import { Spacer } from '@chakra-ui/react';
import { iconNameByIraType } from '@common/react/goals';
import { IconName } from '@common/react/icons';
import { useRetirementGoalContext } from './RetirementGoalDetailContainer';

const OpenableRetirementAccountList = () => {
    const {
        allowOpeningAccounts,
        myPlentyRothIraStatus,
        myPlentyTraditionalIraStatus,
        goalConfig,
        setPosition,
    } = useRetirementGoalContext();

    // If opening is not allowed or both accounts have already been opened,
    // avoid showing header with no content below
    if (
        !allowOpeningAccounts ||
        (myPlentyTraditionalIraStatus === 'CONFIRMED' &&
            myPlentyRothIraStatus === 'CONFIRMED')
    ) {
        return <></>;
    }

    return (
        <FlexCol px={4} py={4}>
            <Text fontWeight={600} fontSize="md" pl={2} py={2} mb={2}>
                Open a new account
            </Text>
            <FlexCol py={4} px={4} gap={8}>
                {myPlentyTraditionalIraStatus !== 'CONFIRMED' && (
                    <OpenableRetirementAccountListItem
                        title="Plenty Traditional IRA"
                        description="Save on taxes now, pay taxes when you withdraw."
                        iconName={iconNameByIraType['TRADITIONAL']}
                        iconColor={goalConfig.color}
                        onClick={() => setPosition('OPEN_TRADITIONAL_IRA')}
                    />
                )}
                {myPlentyRothIraStatus !== 'CONFIRMED' && (
                    <OpenableRetirementAccountListItem
                        title="Plenty Roth IRA"
                        description="Pay taxes now, to skip taxes down the road."
                        iconName={iconNameByIraType['ROTH']}
                        iconColor={goalConfig.color}
                        onClick={() => setPosition('OPEN_ROTH_IRA')}
                    />
                )}
            </FlexCol>
        </FlexCol>
    );
};

export default OpenableRetirementAccountList;

interface OpenableRetirementAccountListItemProps {
    title: string;
    description: string;
    iconName: IconName;
    iconColor: string;
    onClick: VoidFunction;
}

const OpenableRetirementAccountListItem = ({
    title,
    description,
    iconName,
    iconColor,
}: OpenableRetirementAccountListItemProps) => {
    return (
        <FlexRow w="full">
            <Icon name={iconName} color={iconColor} size="lg" mt={1} />
            <FlexCol ml={3} maxW={40}>
                <Text>{title}</Text>
                <Text fontSize="sm" color="gray.400" pr={4}>
                    {description}
                </Text>
            </FlexCol>
            <Spacer />
            <Button
                variant="pill"
                colorScheme="white"
                size="sm"
                h={9}
                mt={1}
                // TODO: Make clickable again when IRAs are ready
                isDisabled
                onClickEvent="Open IRA Button Clicked"
            >
                Coming soon!
            </Button>
        </FlexRow>
    );
};
